import React from "react";
import { useTranslation } from "react-i18next";
import { replaceStringWithShandeChildAmount } from "../../helpers/dataHelper";

function AboutSection() {
    const { t } = useTranslation();
    const photo_url = process.env.REACT_APP_SHANDE_PHOTO_URL;
    const aboutP1 = replaceStringWithShandeChildAmount(t("aboutP1"));
    const badges = [
        { title: t("trustRegisteredTitle"), desc: t("trustRegisteredDesc") },
        { title: t("trustAuditTitle"), desc: t("trustAuditDesc") },
        { title: t("trustReceiptTitle"), desc: t("trustReceiptDesc") },
    ];
    return (
        <section className="landing-section">
            <div className="container">
                <div className="landing-about-grid">
                    <div className="landing-about-media">
                        <img
                            className="landing-about-img"
                            src={photo_url + "homepage/children_online.png"}
                            alt="Shande children's welfare home"
                        />
                        <div className="landing-about-caption">{t("aboutImageCaption")}</div>
                    </div>
                    <div className="landing-about-body">
                        <div className="landing-eyebrow">{t("aboutEyebrow")}</div>
                        <h2 className="landing-heading">{t("aboutTitle1")}<br />{t("aboutTitle2")}</h2>
                        <p className="landing-about-text">{aboutP1}</p>
                        <p className="landing-about-text">{t("aboutP2")}</p>
                        <div className="landing-about-footer">{t("aboutFooter")}</div>
                    </div>
                </div>
                <div className="landing-badges">
                    {badges.map(badge => (
                        <div className="landing-badge" key={badge.title}>
                            <div className="landing-badge-title">{badge.title}</div>
                            <div className="landing-badge-desc">{badge.desc}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
export default AboutSection;